var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"ml-4 mr-4 mb-3 alert",attrs:{"value":_vm.documents.length,"type":"info"}},[_vm._v("\n\tDla następujących dokumentów wskazano więcej niż jedną datę zapłaty: "+_vm._s(_vm.payments.join(", "))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }